export const STEP_STATUS_ACTIVE = 'active';
export const STEP_STATUS_PENDING = 'pending';
export const STEP_STATUS_COMPLETED = 'completed';
export const SCHEDULE_TYPE_SELF = 'self';
export const SCHEDULE_TYPE_BULK_SELF_SCHEDULE = 'bulk-self';
export const SCHEDULE_TYPE_BULK_MANUAL = 'bulk-manual';
export const SCHEDULE_TYPE_MANUAL = 'manual';

export const OFFER_STEPS_APPROVAL = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'OFFER_DETAILS_COMP',
    id: 'offerDetails',
    nextNode: 'offerLetterTemplate',
    prevNode: null,
    submitButtonLabel: 'Next: Offer letter template',
  },
  {
    label: 'Offer letter template',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'OFFER_LETTER_TEMPLATE_COMP',
    id: 'offerLetterTemplate',
    prevNode: 'offerDetails',
    nextNode: 'offerApproval',
    submitButtonLabel: 'Next: Approval',
    previousButtonLabel: 'Back to details',
  },
  {
    label: 'Approval',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'OFFER_APPROVAL_COMP',
    id: 'offerApproval',
    prevNode: 'offerLetterTemplate',
    nextNode: null,
    submitButtonLabel: 'Send offer for approval',
    previousButtonLabel: 'Back to offer letter template',
  },
];

// Skip-flow re-approval edit: the document is already generated, so editing a
// re-approval field only needs Details → Approval (no template step, no skip).
export const OFFER_STEPS_REAPPROVAL_EDIT = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE,
    enabled: true,
    componentRef: 'OFFER_DETAILS_COMP',
    id: 'offerDetails',
    nextNode: 'offerApproval',
    prevNode: null,
    submitButtonLabel: 'Next: Approval',
  },
  {
    label: 'Approval',
    status: STEP_STATUS_PENDING,
    enabled: false,
    componentRef: 'OFFER_APPROVAL_COMP',
    id: 'offerApproval',
    prevNode: 'offerDetails',
    nextNode: null,
    submitButtonLabel: 'Send offer for approval',
    previousButtonLabel: 'Back to details',
  },
];

export const OFFER_STEPS_APPROVAL_DIRECT_NOTE = [
  {
    label: 'Details',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'OFFER_DETAILS_COMP',
    id: 'offerDetails',
    nextNode: 'offerLetterTemplate',
    prevNode: null,
    submitButtonLabel: 'Next: Offer letter template',
  },
  {
    label: 'Offer letter template',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'OFFER_LETTER_TEMPLATE_COMP',
    id: 'offerLetterTemplate',
    prevNode: 'offerDetails',
    nextNode: 'offerApproval',
    submitButtonLabel: 'Next: Approval',
    previousButtonLabel: 'Back to details',
  },
  {
    label: 'Approval',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'OFFER_APPROVAL_COMP',
    id: 'offerApproval',
    prevNode: 'offerLetterTemplate',
    nextNode: null,
    submitButtonLabel: 'Send offer for approval',
    previousButtonLabel: 'Back to offer letter template',
  },
];

export const OFFER_STEPS_WITH_KULA = [
  {
    label: 'Details',
    status: STEP_STATUS_ACTIVE, // 'active', 'completed', 'pending',
    enabled: true,
    componentRef: 'OFFER_DETAILS_COMP',
    id: 'offerDetails',
    nextNode: 'offerLetterTemplate',
    prevNode: null,
    submitButtonLabel: 'Next: Offer letter template',
  },
  {
    label: 'Offer letter template',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'OFFER_LETTER_TEMPLATE_COMP',
    id: 'offerLetterTemplate',
    prevNode: 'offerDetails',
    nextNode: 'offerEmail',
    submitButtonLabel: 'Next: Email',
    previousButtonLabel: 'Back to details',
  },
  {
    label: 'Email',
    status: STEP_STATUS_PENDING, // 'active', 'completed', 'pending',
    enabled: false,
    componentRef: 'OFFER_EMAIL_COMP',
    id: 'offerEmail',
    prevNode: 'offerLetterTemplate',
    nextNode: null,
    submitButtonLabel: 'Send offer with Kula',
    previousButtonLabel: 'Back to offer letter template',
  },
];

// Builds the 2-step template → esign flow used when document_generation_skipped=true.
const makeSendSteps = (providerLabel: string, sendLabel: string) => [
  {
    label: 'Offer letter template',
    status: STEP_STATUS_ACTIVE,
    enabled: true,
    componentRef: 'OFFER_LETTER_TEMPLATE_COMP',
    id: 'offerLetterTemplate',
    prevNode: null,
    nextNode: 'offerEmail',
    submitButtonLabel: `Next: ${providerLabel}`,
  },
  {
    label: providerLabel,
    status: STEP_STATUS_PENDING,
    enabled: false,
    componentRef: 'OFFER_EMAIL_COMP',
    id: 'offerEmail',
    prevNode: 'offerLetterTemplate',
    nextNode: null,
    submitButtonLabel: sendLabel,
    previousButtonLabel: 'Back to offer letter template',
  },
];

// Builds the single-step esign flow used for normal (non-skipped) esign offers.
const makeEsignStep = (providerLabel: string, sendLabel: string) => [
  {
    label: providerLabel,
    status: STEP_STATUS_ACTIVE,
    enabled: true,
    componentRef: 'OFFER_EMAIL_COMP',
    id: 'offerEmail',
    prevNode: null,
    nextNode: null,
    submitButtonLabel: sendLabel,
  },
];

export const OFFER_STEPS_SEND = makeSendSteps('Email', 'Send offer with Kula');
export const OFFER_STEPS_SEND_DOCUSIGN = makeSendSteps(
  'Docusign signature flow',
  'Send offer with Docusign'
);
export const OFFER_STEPS_SEND_PANDADOC = makeSendSteps(
  'Pandadoc signature flow',
  'Send offer with Pandadoc'
);
export const OFFER_STEPS_SEND_ADOBE = makeSendSteps(
  'Adobe Sign signature flow',
  'Send offer with Adobe Sign'
);

export const OFFER_STEPS_ESIGN_DOCUSIGN = makeEsignStep(
  'Docusign signature flow',
  'Send offer with Docusign'
);
export const OFFER_STEPS_ESIGN_PANDADOC = makeEsignStep(
  'Pandadoc signature flow',
  'Send offer with Pandadoc'
);
export const OFFER_STEPS_ESIGN_ADOBE = makeEsignStep(
  'Adobe Sign signature flow',
  'Send offer with Adobe Sign'
);

export const getOfferSteps = (
  isApprovalEnabled: boolean,
  redirectToSendForApprovalTab: boolean
) => {
  if (isApprovalEnabled && redirectToSendForApprovalTab) {
    return OFFER_STEPS_APPROVAL_DIRECT_NOTE;
  }
  if (isApprovalEnabled) {
    return OFFER_STEPS_APPROVAL;
  }
  return OFFER_STEPS_WITH_KULA;
};
